import { OfaText, useTranslation } from "@fortius/prime-ui";
import * as Styled from "./index.styled";
import { IBankTransferDetails } from "features/common";
import React from "react";

export interface IBankTransferDetailsProps {
  bankTransferDetails: IBankTransferDetails;
  textSize?: "l" | "m" | "s";
}

export const BankTransferDetails: React.FC<IBankTransferDetailsProps> = ({
  bankTransferDetails,
  textSize = "l"
}) => {
  const { t: translate } = useTranslation();

  return (
    <Styled.BankTransferDetails
      className="bank-transfer-details"
      data-testid="bank-transfer-details"
    >
      {Object.entries(bankTransferDetails).map(([key, value]) => {
        if (key === "title" || key === "body") {
          return null;
        }

        return (
          <React.Fragment key={key}>
            <OfaText as="dt" size={textSize} data-testid={`bank-transfer-detail-title-${key}`}>
              {translate(`signup.checkout.bankTransferDetails.title_${key}`)}
            </OfaText>
            <OfaText
              as="dd"
              size={textSize}
              weight="bold"
              data-testid={`bank-transfer-detail-description-${key}`}
            >
              {value}
            </OfaText>
          </React.Fragment>
        );
      })}
    </Styled.BankTransferDetails>
  );
};
